/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import { FSFBWebEventBundle } from './fsfbweb-event-bundle';
import { FSFBWebEventLoad } from './fsfbweb-event-load';
import { FSFBWebEventLoadNotRecorded } from './fsfbweb-event-load-not-recorded';
import { FSFBWebEventUnload } from './fsfbweb-event-unload';

export enum FSFBWebEvent {
  NONE = 0,
  FSFBWebEventLoad = 1,
  FSFBWebEventLoadNotRecorded = 2,
  FSFBWebEventUnload = 3,
  FSFBWebEventBundle = 4,
}

export function unionToFsfbwebEvent(
  type: FSFBWebEvent,
  accessor: (
    obj: FSFBWebEventBundle | FSFBWebEventLoad | FSFBWebEventLoadNotRecorded | FSFBWebEventUnload,
  ) =>
    | FSFBWebEventBundle
    | FSFBWebEventLoad
    | FSFBWebEventLoadNotRecorded
    | FSFBWebEventUnload
    | null,
): FSFBWebEventBundle | FSFBWebEventLoad | FSFBWebEventLoadNotRecorded | FSFBWebEventUnload | null {
  switch (FSFBWebEvent[type]) {
    case 'NONE':
      return null;
    case 'FSFBWebEventLoad':
      return accessor(new FSFBWebEventLoad())! as FSFBWebEventLoad;
    case 'FSFBWebEventLoadNotRecorded':
      return accessor(new FSFBWebEventLoadNotRecorded())! as FSFBWebEventLoadNotRecorded;
    case 'FSFBWebEventUnload':
      return accessor(new FSFBWebEventUnload())! as FSFBWebEventUnload;
    case 'FSFBWebEventBundle':
      return accessor(new FSFBWebEventBundle())! as FSFBWebEventBundle;
    default:
      return null;
  }
}

export function unionListToFsfbwebEvent(
  type: FSFBWebEvent,
  accessor: (
    index: number,
    obj: FSFBWebEventBundle | FSFBWebEventLoad | FSFBWebEventLoadNotRecorded | FSFBWebEventUnload,
  ) =>
    | FSFBWebEventBundle
    | FSFBWebEventLoad
    | FSFBWebEventLoadNotRecorded
    | FSFBWebEventUnload
    | null,
  index: number,
): FSFBWebEventBundle | FSFBWebEventLoad | FSFBWebEventLoadNotRecorded | FSFBWebEventUnload | null {
  switch (FSFBWebEvent[type]) {
    case 'NONE':
      return null;
    case 'FSFBWebEventLoad':
      return accessor(index, new FSFBWebEventLoad())! as FSFBWebEventLoad;
    case 'FSFBWebEventLoadNotRecorded':
      return accessor(index, new FSFBWebEventLoadNotRecorded())! as FSFBWebEventLoadNotRecorded;
    case 'FSFBWebEventUnload':
      return accessor(index, new FSFBWebEventUnload())! as FSFBWebEventUnload;
    case 'FSFBWebEventBundle':
      return accessor(index, new FSFBWebEventBundle())! as FSFBWebEventBundle;
    default:
      return null;
  }
}
